// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap);"]);
// Module
exports.push([module.id, "body {\n    margin: 0;\n    padding: 0;\n    font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n}\nhtml {\n    overflow-y: scroll;\n}\nul[role=\"listbox\"] div[role=\"menuitem\"] {\n    font-size: 1.5rem;\n}\nul[role=\"listbox\"] li {\n    font-size: 1.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
